import { render, staticRenderFns } from "./Chuang.vue?vue&type=template&id=6ad4b92c&scoped=true&"
import script from "./Chuang.vue?vue&type=script&lang=js&"
export * from "./Chuang.vue?vue&type=script&lang=js&"
import style0 from "./Chuang.vue?vue&type=style&index=0&id=6ad4b92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4b92c",
  null
  
)

export default component.exports